export default __webpack_public_path__ + "static/media/fw-olivia-er-White Gold.54b4f044.mp4";